// extracted by css-extract-rspack-plugin
export default {"widgets":"WRXbL6tLcxsKLfyd"};